import {ValueObject} from '@s-ui/domain'

/**
 * @export
 * @class ConfigSmartbannerValueObject
 * @extends {ValueObject}
 */
export default class ConfigSmartbannerValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} deps
   * @param {String} deps.buttonUrl
   * @param {String} deps.iconUrl
   * @param {Boolean} deps.showSmartbanner
   * @param {Number} deps.ratingValue
   */
  constructor({buttonUrl, iconUrl, showSmartbanner, ratingValue}) {
    super({
      buttonUrl,
      iconUrl,
      showSmartbanner,
      ratingValue
    })
    this._buttonUrl = buttonUrl
    this._iconUrl = iconUrl
    this._showSmartbanner = showSmartbanner
    this._ratingValue = ratingValue
  }

  roundHalf = num => Math.round(num * 2) / 2

  /**
   * @return {Object}
   */
  toJSON = () => ({
    show: this._showSmartbanner,
    buttonUrl: this._buttonUrl,
    iconUrl: this._iconUrl,
    ratingValue: this.roundHalf(this._ratingValue)
  })
}
